import EmailSignupForm from "@/components/wynn/EmailSignupForm";
import { CheckCircle2 } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_five-min-formula/artifacts/xl70jip2_WYNN%20%282%29.png";

const betaPerks = [
  "Lifetime access at founding-member pricing",
  "First to shape the prompts, voice and rituals inside",
  "A private channel to whisper feedback directly to me",
  "Your name in the credits of v1, if you want it there",
];

export default function BetaCTA() {
  return (
    <section data-testid="wynn-beta" className="relative border-t border-[#F4F1EC]/10 overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, rgba(255,170,210,0.08) 0%, rgba(120,200,230,0.08) 50%, rgba(180,140,230,0.08) 100%)",
        }}
      />
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-10 items-start">
          <div className="col-span-12 md:col-span-6">
            <div className="text-[11px] uppercase tracking-[0.32em] text-[#FFB7C6] font-body">
              Beta testers wanted
            </div>
            <h2 className="mt-4 font-display tracking-tight leading-[1.02] text-[clamp(2rem,4.6vw,3.6rem)] font-medium text-[#F4F1EC]">
              Help me shape <br />
              <span className="italic font-light text-aurora">something gentle</span>.
            </h2>
            <p className="mt-6 font-body text-[#F4F1EC]/75 text-lg leading-[1.75] max-w-xl">
              I&apos;m inviting a small first circle of artists into the closed
              beta. You&apos;ll get the app early, weave your voice into the
              prompts and rituals, and keep founding-member pricing for life.
              Quiet, generous, and a little sacred.
            </p>

            <ul className="mt-10 space-y-4">
              {betaPerks.map((perk, i) => (
                <li
                  key={i}
                  data-testid={`wynn-perk-${i + 1}`}
                  className="flex items-start gap-3 font-body text-[15px] text-[#F4F1EC]/85 leading-relaxed"
                >
                  <CheckCircle2 size={18} strokeWidth={1.5} className="text-[#A8E6FF] mt-0.5 shrink-0" />
                  <span>{perk}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <div className="border border-[#F4F1EC]/15 bg-[#F4F1EC]/[0.035] backdrop-blur-sm p-8 md:p-10">
              <div className="flex items-center gap-4 mb-6">
                <img src={LOGO} alt="" className="w-14 h-14 object-contain" aria-hidden />
                <div>
                  <div className="font-display text-[22px] leading-none tracking-tight text-[#F4F1EC]">
                    Join the beta circle
                  </div>
                  <div className="mt-2 text-[10px] uppercase tracking-[0.3em] text-[#F4F1EC]/55 font-body">
                    Small first circle · Free to join
                  </div>
                </div>
              </div>

              <EmailSignupForm
                source="wynn_beta"
                testIdPrefix="wynn-beta"
                buttonLabel="Join the beta"
                successDescription="You're on the beta list. I'll reach out personally when invites open."
              />

              <p className="mt-6 font-body text-xs text-[#F4F1EC]/45 leading-relaxed">
                Same waitlist, deeper involvement. Join if you want to test, give
                feedback, and help me build it gently.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
